import * as React from 'react'
import MuiCheckbox, {
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material/Checkbox'
import FormControlLabel, {
  FormControlLabelProps as MuiLabelProps,
} from '@mui/material/FormControlLabel'
import { FieldProps } from 'formik'

interface Props
  extends FieldProps,
    Omit<MuiCheckboxProps, 'name' | 'value' | 'form'> {
  label: string
  margin?: number
  labelProps: Omit<MuiLabelProps, 'label' | 'control'>
}

export const MuiCheckboxFormik: React.FC<Props> = ({
  form: { isSubmitting }, //, errors, touched },
  disabled = isSubmitting,
  field: { onBlur: fieldOnBlur, ...field },
  onBlur = fieldOnBlur,
  label,
  labelProps,
  margin,
  ...props
}) => {
  const switchProps = {
    checked: field.value,
    ...field,
    ...props,
    disabled,
    onBlur: React.useCallback(
      (event: React.FocusEvent<HTMLButtonElement>) => {
        if (onBlur) {
          onBlur(event)
        } else {
          fieldOnBlur(event ?? field.name)
        }
      },
      [field.name, fieldOnBlur, onBlur],
    ),
  }
  return (
    <FormControlLabel
      {...labelProps}
      label={label}
      sx={{ margin: margin }}
      control={<MuiCheckbox {...switchProps} />}
      data-test-id={`${label}-checkbox`}
    />
  )
}
MuiCheckboxFormik.displayName = 'MuiSwitchFormik'
